module.exports = __webpack_public_path__ + "img/gaming-experience.334ab4c6.svg";